'use client';

import { orgBannerProps } from '@/libs/interfaceProps/orgBannerProps';
import { createContext, useContext, useState, ReactNode } from 'react';

// Create the context with a default value of undefined
const orgContext = createContext<{
  orgData: orgBannerProps;
  setOrgData: React.Dispatch<React.SetStateAction<orgBannerProps>>;
}>({
  orgData: {
    orgName: '',
    orgDescription: '',
    orgNumFound: 0,
    orgUrl: '',
    peDemandSub: false,
    clientLogoBanner: '',
    clientLogoBannerMobile: '',
    btChannelIds: [],
    images: null,
    hasCustomBanner: false
  },
  setOrgData: () => {}
});

// Wrapper component to provide the context
export function OrgWrapper({
  children
}: {
  children: ReactNode;
}) {
  const [orgData, setOrgData] = useState<orgBannerProps>({
    orgName: '',
    orgDescription: '',
    orgNumFound: 0,
    orgUrl: '',
    peDemandSub: false,
    clientLogoBanner: '',
    btChannelIds: [],
    images: null,
    hasCustomBanner: false
  });
  return <orgContext.Provider value={{
    orgData,
    setOrgData
  }} data-sentry-element="unknown" data-sentry-component="OrgWrapper" data-sentry-source-file="orgContext.tsx">
   {children}
  </orgContext.Provider>;
}

// Hook to use the context
export function useOrgContext() {
  const context = useContext(orgContext);
  if (!context) {
    throw new Error('useOrgContext must be used within an OrgContextWrapper');
  }
  return context;
}